export default "__VITE_ASSET__43ddc665__"